'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactSideEffect = require('react-side-effect');

var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _underscore = require('underscore');

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BodyClassName = function (_Component) {
  _inherits(BodyClassName, _Component);

  function BodyClassName() {
    _classCallCheck(this, BodyClassName);

    return _possibleConstructorReturn(this, (BodyClassName.__proto__ || Object.getPrototypeOf(BodyClassName)).apply(this, arguments));
  }

  _createClass(BodyClassName, [{
    key: 'render',
    value: function render() {
      return _react.Children.only(this.props.children);
    }
  }]);

  return BodyClassName;
}(_react.Component);

BodyClassName.propTypes = {
  className: _propTypes2.default.string.isRequired
};


var reducePropsToState = function reducePropsToState(propsList) {
  return (0, _classnames2.default)(_underscore2.default.pluck(propsList, 'className').join(' '));
};
var handleStateChangeOnClient = function handleStateChangeOnClient(className) {
  return document.body.className = (0, _classnames2.default)(document.body.class, className);
};

exports.default = (0, _reactSideEffect2.default)(reducePropsToState, handleStateChangeOnClient)(BodyClassName);


//////////////////
// WEBPACK FOOTER
// ./~/react-fast-ui/lib/components/BodyClassName.js
// module id = 391
// module chunks = 0